import React from 'react'
import { postEliminarSuministros } from '../../../services/PaginaRuta'

const ModalEliminarUnSuministro = ({item,setmodalOnEliminarSuministros, passSuministro}) => {
    const usuarioInfo = JSON.parse(localStorage.getItem('usuarioInfo'));
    const handleCancelarClick=()=>{
        setmodalOnEliminarSuministros(false)
    }

    const handleOnclickEliminar=()=>{
        //console.log(item,'itremmmmmmmm')
        const body={
            varProEmpCod:usuarioInfo.Empresa,
            varProMCDpto:usuarioInfo.Sede,
            varProCirCod: item.ProCirCod,
            varPaqCod:item.PaqCod,
            varMSRESO: item.MSRESO
        }
        postEliminarSuministros(body).then((res)=>{
            //console.log(res,'Eliminar Suministro')
            setmodalOnEliminarSuministros(false)
            passSuministro(body)
        })
    }

  return (
    <div
        className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto bg-slate-900 bg-opacity-25"
        id="exampleModalScrollable"
        tabIndex="-1"
        aria-labelledby="exampleModalScrollableLabel"
        aria-hidden="true"
        >
        <div className="sm:h-[calc(100%-3rem)] max-w-2xl my-6 mx-auto relative w-auto pointer-events-none ">
            <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
            <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md bg-[#05a29d]">
                <h5
                className="text-xl font-medium leading-normal text-gray-800"
                id="exampleModalScrollableLabel"
                >
                Confirmar
                </h5>
                <button
                type="button"
                onClick={handleCancelarClick}
                className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                data-bs-dismiss="modal"
                aria-label="Close"
                >
                X
                </button>
            </div>
            <div className="flex-auto overflow-y-auto relative p-4">
                <div className="flex py-2 text-left">
                <div className="w-3/3  px-4">
                    <label className="form-label inline-block mb-2 text-gray-900 font-medium">
                    Desea realmente eliminar el suministro {item.MSRESO} de la cirugia {item.ProCirCod}
                    </label>
                    
                </div>
                </div>
                
            </div>
            <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-4 border-t border-gray-200 rounded-b-md">
                <button
                type="button"
                onClick={handleCancelarClick}
                className="inline-block px-6 py-2.5 bg-purple-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                data-bs-dismiss="modal"
                >
                No
                </button>
                <button type="button"
                onClick={handleOnclickEliminar}
                className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1">
                Si
                </button>
            </div>
            </div>
        </div>
        </div>
  )
}

export default ModalEliminarUnSuministro